/**
 * Bite Balance Activity API Configuration
 * Contains all API-related constants and configuration values
 */

// API Configuration
export const ACTIVITY_API_CONFIG = {
  // Base API URL for Django backend
  BASE_URL: import.meta.env.VITE_API_BASE_URL,

  // Tenant ID for multi-tenant architecture
  TENANT_ID: "ab9bb443-b2ef-4b55-b0ed-0b4a41bb2dc8",

  // Endpoints for activity data
  ENDPOINTS: {
    FITBIT_SCAN: "/fitbit_scan/daily/",
    FITBIT_SCAN_ALT: "/fitbit_scan/daily",
    FITBIT_SCAN_DASH: "/fitbit-scan/daily/",
  },

  // Request configuration
  TIMEOUT: 30000, // 30 seconds

  // Cache configuration
  CACHE_DURATION: 5 * 60 * 1000, // 5 minutes in milliseconds

  // Default values
  DEFAULTS: {
    STEPS_TARGET: 10000,
    STRESS_LEVEL: "Normal",
  },
} as const;

// Type-safe endpoint getter
export const getActivityEndpoints = () => [
  ACTIVITY_API_CONFIG.BASE_URL + ACTIVITY_API_CONFIG.ENDPOINTS.FITBIT_SCAN,
  ACTIVITY_API_CONFIG.BASE_URL + ACTIVITY_API_CONFIG.ENDPOINTS.FITBIT_SCAN_ALT,
  ACTIVITY_API_CONFIG.BASE_URL + ACTIVITY_API_CONFIG.ENDPOINTS.FITBIT_SCAN_DASH,
];

export default ACTIVITY_API_CONFIG;
